<div class="flex justify-center px-8 ">
    <h2
        class="text-center font-medium leading-relaxed text-2xl mt-8 p-4 text-gray-800 bg-evaluationto rounded-md cursor-default">
        {{name}}
        <br>
        ({{action}} - {{city}})
    </h2>
</div>
<div *ngIf="this.is20 == true" class="flex justify-center mt-2">
    <img src="../../../../../../../../../assets/img/kpi20.png" class="rounded">
</div>
<div id="templateContainer"></div>
<div class="font-medium leading-relaxed text-md mx-8 text-red-600 cursor-default">{{footNotes}}</div>